import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-details-three',
  templateUrl: './blog-details-three.component.html',
  styleUrls: ['./blog-details-three.component.scss']
})
export class BlogDetailsThreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
